module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ArticleBox":{"linkReadMore":"Číst dál"}},"de":{"ArticleBox":{"linkReadMore":"Den Artikel lesen"}},"sk":{"ArticleBox":{"linkReadMore":"Prečítať článok"}}}')
  delete Component.options._Ctor
}
